import React from 'react'
import { shouldShowNewCustomerDiscountTimerUserSelect } from 'modules/training/modules/training-users/selectors/shouldShowNewCustomerDiscountTimer/index.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { NewCustomerDiscountTimerContent } from 'pages/Premium/FreeVsPremiumFeatures/SubscriptionPlanPicker/NewCustomerDiscountTimer/Content/index.js'

/**
 * @param isCompact
 * @returns {JSX.Element}
 * @constructor
 */
export function NewCustomerDiscountTimer ({ isCompact }) {
  const shouldShow = useSelector(shouldShowNewCustomerDiscountTimerUserSelect)
  if (!shouldShow) {
    return <></>
  }

  return (
    <NewCustomerDiscountTimerContent
      shouldShow
      isCompact={isCompact}
    />
  )
}
